<template>
  <div>
    <label-field :for="field.id" :field="field" />
    <input
      v-currency="{
        locale: 'en',
        currency: 'USD',
        valueRange: {
          min: 0,
          max: 99999,
        },
      }"
      :id="field.id"
      :aria-describedby="field.id + 'Help'"
      ref="input"
      v-model="field.value"
      :required="field.required"
      :placeholder="field.placeholder"
      :disabled="disabled"
      @focusout="checkTextBoxError"
      autocomplete="off"
    />
    <input-error v-if="textBoxError" :value="textBoxErrorMsg" />
  </div>
</template>

<script>
  import LabelField from "./LabelField";
  import { CurrencyDirective } from "vue-currency-input";
  import InputError from "./InputError";
  import { formatCurrencyInput, formatAmountUSD } from "@/utils/formatting";

  export default {
    name: "CurrencyField",
    directives: {
      currency: CurrencyDirective,
    },
    components: { InputError, LabelField },
    data: () => ({
      // This is specifically for v-currency as a default so we can see our :placeholder.
      // We have the option to set any default integer or floating point number we want.
      textBoxError: false,
      textBoxErrorMsg: "",
    }),
    props: {
      field: {
        id: "",
        label: "",
        required: false,
        value: "",
        placeholder: "",
      },
      disabled: Boolean,
      minAmount: null,
      maxAmount: null,
      zeroMsg: {
        type: String,
        default: "",
      },
      minMsg: {
        type: String,
        default: "",
      },
      maxMsg: {
        type: String,
        default: "",
      },
      showError: {
        value: false,
      },
    },
    methods: {
      checkTextBoxError: function () {
        this.textBoxError = false;
        this.textBoxErrorMsg = "";

        if (this.field.required && !this.field.value) {
          this.textBoxError = true;
          this.textBoxErrorMsg = "Field is required";
        } else {
          const currentPaymentAmount = formatCurrencyInput(this.field.value);
          if (this.minAmount && currentPaymentAmount < this.minAmount) {
            const formattedMinAmount = formatAmountUSD(this.minAmount);
            this.textBoxError = true;
            this.textBoxErrorMsg =
              this.minMsg || `Cannot be less than $${formattedMinAmount}`;
          } else if (currentPaymentAmount <= 0.0) {
            this.textBoxError = true;
            this.textBoxErrorMsg =
              this.zeroMsg || "You cannot submit a $0 payment.";
          } else if (this.maxAmount && this.maxAmount < currentPaymentAmount) {
            const formattedMaxAmount = formatAmountUSD(this.maxAmount);
            this.textBoxError = true;
            this.textBoxErrorMsg =
              this.maxMsg || `Cannot be more than $${formattedMaxAmount}`;
          }
        }
        this.$emit("valid", !this.textBoxErrorMsg);
      },
    },
    watch: {
      // this.field.value will be a number unless we want it to be string
      showError() {
        this.textBoxError =
          this.showError && this.field.required && !this.field.value;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "src/assets/_scss/main";
  /* @TODO we can probably move this up to global or main. It's sibling is in LabelField */
  .error-class {
    border-color: #cc0000 !important;
  }

  p {
    margin: 5px 0 0;
  }

  #amount {
    max-width: 150px;

    &:disabled {
      color: #909090;
    }
  }

  input {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
    font-size: 14px;
    max-width: 100%;
    background: #fff;
    color: #000;
    border: 1px solid #d4d8db;
    border-radius: 4px;
    -webkit-appearance: textfield;
  }
</style>
